// extracted by mini-css-extract-plugin
export default {"PlanAccessBadge":"PlanAccessBadge1Ot_QCvF3zh8","PlanAccessBadge_iconOnly":"PlanAccessBadge_iconOnly3HBjEsxN0RWp","PlanAccessBadge-banner":"PlanAccessBadge-banner1-E-vNVpe3tp"};